export default {"src":"/_next/static/media/adventurewurld.3042d280.svg","height":144,"width":144};